import Dropdown from '@jetbrains/ring-ui/components/dropdown/dropdown'
import {memo, useCallback} from 'react'

import {getBuild, getTagsLabel} from '../../../../../selectors'
import type {BuildId} from '../../../../../types'
import BuildTag from '../../../BuildTag/BuildTag'
import Popup from '../../../Popup/Popup.lazy'
import BuildTagsList from '../../../TagsList/TagsList.container'

import styles from './BuildTagDropdown.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  buildId: BuildId
  tagsNumber: number
  className?: string
}
function BuildTagDropdown({buildId, tagsNumber, className}: Props) {
  const label = useAppSelector(state => getTagsLabel(state, buildId))
  const buildTypeId = useAppSelector(state => getBuild(state, buildId)?.buildType)
  const hasSeveralLabels = tagsNumber > 1

  const renderBuildTag = useCallback(
    (localClassName?: string) => (
      <BuildTag
        className={localClassName}
        label={label}
        multiple={hasSeveralLabels}
        buildTypeId={buildTypeId}
        buildId={buildId}
      />
    ),
    [label, hasSeveralLabels, buildTypeId, buildId],
  )

  return hasSeveralLabels ? (
    <Dropdown anchor={renderBuildTag()} className={className} hoverMode>
      <Popup className={styles.popup}>
        <BuildTagsList buildId={buildId} />
      </Popup>
    </Dropdown>
  ) : (
    renderBuildTag(className)
  )
}

export default memo(BuildTagDropdown)
